import React from 'react';

const IconChevronRight = () => (
  <svg width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 16L8.5 8.5L1 1" stroke="currentColor" />
  </svg>
);

export default IconChevronRight;
